import {
  getBinCriterion,
  getOfferingOptionCriterion,
  getSchoolCriterion,
  type EntityCriterion,
} from "src/generated/hooks/form-service/requests";
import {
  parseCriterion,
  type ConditionsDescription,
  type ConditionsFormValues,
} from "./conditionsForm";

export type LoadedCriterion = {
  criterion:
    | (EntityCriterion & {
        inheritConditions?: boolean;
      })
    | null;
  description: ConditionsDescription;
  formValues: ConditionsFormValues;
};

export async function fetchOfferingOptionCriterion({
  enrollmentPeriodId,
  criteriaSetId,
  offeringOptionId,
}: {
  enrollmentPeriodId: string;
  criteriaSetId: string;
  offeringOptionId: string;
}): Promise<LoadedCriterion> {
  const response = await getOfferingOptionCriterion({
    throwOnError: false,
    path: { enrollmentPeriodId, criteriaSetId, offeringOptionId },
  });
  return criterionFromResponse(response);
}

export async function fetchSchoolCriterion({
  enrollmentPeriodId,
  criteriaSetId,
  schoolId,
}: {
  enrollmentPeriodId: string;
  criteriaSetId: string;
  schoolId: string;
}): Promise<LoadedCriterion> {
  const response = await getSchoolCriterion({
    throwOnError: false,
    path: { enrollmentPeriodId, criteriaSetId, schoolId },
  });
  return criterionFromResponse(response);
}

export async function fetchBinCriterion({
  enrollmentPeriodId,
  criteriaSetId,
  binId,
}: {
  enrollmentPeriodId: string;
  criteriaSetId: string;
  binId: string;
}): Promise<LoadedCriterion> {
  const response = await getBinCriterion({
    throwOnError: false,
    path: { enrollmentPeriodId, criteriaSetId, binId },
  });
  return criterionFromResponse(response);
}

function criterionFromResponse<TCriterion extends EntityCriterion>(response: {
  data?: { data?: TCriterion | null };
  error?: { error: { message: string } };
  response: { status: number };
}): LoadedCriterion {
  let criterion: TCriterion | null = null;
  if (response.error)
    if (response.response.status === 404) {
      // 404 means the criterion does not exist
      criterion = null;
    } else {
      throw new Error(response.error.error.message);
    }
  else {
    criterion = response.data?.data ?? null;
  }
  return { criterion, ...parseCriterion(criterion) };
}
